export default __webpack_public_path__ + "static/media/ic-favicon.7732a04d.svg";